module.exports = __webpack_public_path__ + "img/bs.bb311b4d.svg";